module.exports = {
    "language": {
        "name": "English",
        "code": "en-US",
        "codeShort": "en"
    },
    "common": {
        "acceptAgbText": "Hereby I confirm that I have read the <1>Terms and Conditions</1> and accept them.",
        "dataProtection": "data protection",
        "imprint": "imprint",
        "administration": "Administration",
        "settings": "Settings",
        "settingsDesc": "Edit your settings",
        "logoAlt": "3m5 Logo",
        "navLabelExampleForm": "Example",
        "navDescExampleForm": "Example Description",
        "profileUpdateSuccessModalText": "Profile was updated successfully.\nPlease sign-in again.",
        "passwordResetSuccessModalText": "Password has been reset successfully. \nPlease sign-in with your new password.",
        "navLabelDashboard": "Dashboard",
        "navDescDashboard": "Home",
        "navLabelBusiness": "Company",
        "navDescBusiness": "Company",
        "navLabelUser": "User",
        "navDescUser": "User",
        "navLabelInviteColleagues": "Invite colleagues",
        "navHeaderInviteColleagues": "Invite your colleagues to the SAF-HOLLAND I.Q. PORTAL",
        "navDescInviteColleagues": "Invite colleagues",
        "navLabelEmpolis": "Knowledge Center",
        "navDescEmpolis": "All documents at a glance",
        "navLabelPod": "POD",
        "navDescPod": "Our spare parts shop \"Parts On Demand\"",
        "navLabelServiceReportOnline": "Service Report",
        "navDescServiceReportOnline": "Contact form for warranty inquiries",
        "navLabelTrainings": "Trainings",
        "navDescTrainings": "Learnings",
        "navLabelSpareAxleRequest": "Spare Axle Request",
        "navHeaderSpareAxleRequest": "Spare Axle Request",
        "navDescSpareAxleRequest": "Reach your destination quickly and easily. Spare axle request form.",
        "headSpareAxleRequest": "Reach your destination quickly and easily. Spare axle request form.",
        "register": "Register",
        "salutation": "Salutation",
        "firstName": "First name",
        "participatingCompany": "Participating Company",
        "courseName": "Name training",
        "attendeesName": "Name attendees",
        "streetNr": "Street, No.",
        "surname": "Surname",
        "eMail": "Email",
        "street": "Street",
        "country": "Country",
        "zip": "ZIP-Code",
        "city": "City",
        "phone": "Phone",
        "phoneNr": "Phone",
        "businessSegment": "Business segment",
        "customerNumber": "Customer number",
        "ustIdNr": "VAT number",
        "tryAgain": "Try again",
        "editAzureProfile": "Edit Azure Profile",
        "streetAndNumber": "Street and number",
        "companyName": "Company name",
        "vatId": "vat id",
        "partsOnDemand": "POD",
        "reklamation": "Service Report",
        "knowledgePortal": "Knowledge Center",
        "onlineForm": "Online Form",
        "serviceTeam": "Service Team",
        "misterAbbreviation": "Mr.",
        "missusAbbreviation": "Ms./Mrs.",
        "doctorAbbreviation": "Dr.",
        "professorAbbreviation": "Prof.",
        "inviteColleague": "Invite colleagues",
        "submitInviteInviteColleagueSuccess": "Invite colleagues successfully",
        "submitInviteInviteColleagueFailure": "An error occurred while submitting the form. Please try again in a few minutes.",
        "submitInviteInviteColleagueFailure_UserExists": "Der Benutzer kann nicht eingeladen werden, weil die E-Mail-Adresse im System schon vergeben ist.",
        "navLabelRegistrationCourse": "Registration presence training",
        "navHeaderRegistrationCourse": "Registration for the presence training",
        "axleBody": "Axle Body",
        "completeAxle": "Complete Axle",
        "completeAggregate": "Complete Aggregate",
        "serialNumber": "Serial Number",
        "axleComponent": "Which component do you want to replace?",
        "optionalInfoText": "Additional information",
        "contactDetails": "Contact Details",
        "axleDetails": "Axle Details",
        "component": "Component",
        "optionalInfo": "Additional information",
        "navTrainings": "Trainings",
        "navLabelRegistration": "Registration",
        "navDescRegistration": "Registration",
        "step1contactDetails": "1. Contact Details",
        "step2axleDetails": "2. Axle Data",
        "step3Summary": "3. Summary",
        "submitRegistrationCourseSuccess": "Registration successful",
        "submitRegistrationCourseFailure": "Registration failed",
        "registrationCourseHeader": "Registration presence training",
        "registrationCourseSubHeader": "Enter your data",
        "registrationCourseDescription": "All fields marked with * are mandatory and must be filled in to submit. The trainings take place according to the corona rules in force at the time.",
        "registrationCourseInputLabelCourseName": "Course name",
        "registrationCourseInputLabelCompanyName": "Participating company",
        "registrationCourseInputLabelStreetNr": "Street, No",
        "registrationCourseInputLabelZipCity": "Postcode, City",
        "registrationCourseInputLabelPhoneNr": "Telephone",
        "registrationCourseInputLabelEmail": "E-mail address",
        "registrationCourseInputLabelAttendeesName": "Participant {{number}} name",
        "registrationCourseInputLabelAgbAccepted": "I accept the <1>general conditions of participation.</1>",
        "registrationCourseButtonLabelRegister": "Register",
        "registrationCourseCoronaInfo": "The trainings take place according to the corona rules in force at that time",
        "navLabelAcademy": "Academy",
        "academyPageHeadline": "SAF-HOLLAND ACADEMY",
        "academyText1": "You would like to get to know our products, refresh your knowledge or deepen it? Then you have come to the right place. In our SAF-HOLLAND Academy portal you will not only find basic training courses for our entire product portfolio, but also specialized training courses for specific products and topics. Whether online, on-site at your location or in our SAF-HOLLAND Academy, there is something for everyone.",
        "academyText2": "SAF-HOLLAND training courses cover basic topics around service and spare parts for the entire product portfolio as well as specialist content for specific products. Our training courses have proven themselves in practice and are providing not only technical expertise but also practical experience, which means real added value for the participants.",
        "toAcademy": "To registration",
        "myProfile": "My Profile",
        "dashboardPageHeadline": "Welcome to SAF HOLLAND I.Q. PORTAL",
        "dashboardTextHeadline": "The SAF-HOLLAND I.Q. PORTAL: Intelligent Quality at a Click.",
        "dashboardText1": "Are you looking for data, documents or information on ordering spare parts or on a complaint? Here you will find service quality in an intelligent online platform - quickly and individually filtered with a practical full-text search and smart hit display.",
        "dashboardText2": "The smart search function of the Knowledge Center also finds your desired information in PDF documents and images. Get quick access to the complete technical documentation for all SAF-HOLLAND products and the POD.",
        "dashboardText3": "But your complaints are also in good hands here: With just a few clicks, you can submit a complaint to our service team using an online form.",
        "serviceReportOnlinePageHeadline": "Service Report",
        "serviceReportOnlineTextHeadline": "Pass on complaints promptly.",
        "serviceReportOnlineText1": "You have discovered a defect in the delivery of products or a technical problem? We quickly take away all your worries and take care of your complaint!",
        "serviceReportOnlineText2": "In the Service Report you will find quick help: Simply note your complaint in the form provided, enter your contact details and send the document easily and securely to our service team directly. Here, the case will be checked promptly and you will receive feedback on your claim just as quickly.",
        "serviceReportOnlineImgLabel": "Hello, I am a little blind text. And I have been for as long as I can remember. It wasn't easy to understand what it means to be a blind text: You don't make sense.",
        "startRequest": "Start request",
        "empolisPageHeadline": "Knowledge Center",
        "empolisTextHeadline": "Technology topics quickly found.",
        "empolisText1": "The Knowledge Center by SAF-HOLLAND is exactly the right information management system for everyone who wants to access up-to-date knowledge 24/7. Here you will find a variety of documents and news on all product groups and accessories - clearly arranged in different info formats. Are you looking for a specific user manual, want to read up on a technology or find details about a product?",
        "empolisText2": "In the Knowledge Center you can choose between different product groups and information types to narrow down your search. Using the intelligent full text search, you can also enter any keywords or problems directly. The system will automatically guide you to the appropriate document or to the answer it has found. The search terms you defined are then even highlighted in the text found. In the menu, you can also further expand your Knowledge Center and, for example, bookmark interesting sources, call up news directly or view your search history.",
        "empolisImgLabel": "Hello, I am a little blind text. And I have been for as long as I can remember. It wasn't easy to understand what it means to be a blind text: You don't make sense.",
        "toKnowledgePortal": "To the Knowledge Center",
        "partsOnDemandPageHeadline": "POD (Parts On Demand)",
        "partsOnDemandTextHeadline": "Order spare parts at any time.",
        "partsOnDemandText1": "Are you looking for a specific spare part for your SAF-HOLLAND product and want to order the right one quickly? Then this is the best place to find it! In the portal area POD (Parts On Demand) portal area you will not only find detailed information on all currently available spare parts, but you can also order your selection directly via the customer platform.",
        "partsOnDemandText2": "The faster a spare part is available, the better, because downtime slows down your business. We know how important it is for you to get back on the road quickly and have optimized our spare parts logistics with this in mind. That's why you can now search directly online for the part you need and order it via the POD. The POD also gives you an overview of all articles and product groups - here you can browse for spare parts at your leisure and find more information.",
        "partsOnDemandImgLabel": "Hello, I am a little blind text. And I have been for as long as I can remember. It wasn't easy to understand what it means to be a blind text: You don't make sense.",
        "toPodPortal": "Go to POD",
        "trainingsPageHeadline": "Learnings",
        "trainingsTextHeadline1": "Basic Training - Product Overview I - General and Axles",
        "trainingsTextHeadline2": "Basic Training - Product Overview II - Disc Brakes",
        "trainingsTextHeadline3": "Basic Training - Product Overview III - Suspension systems and accessories",
        "profileUpdateSuccess": "Profile has been updated successfully. \nPlease sign-in again.",
        "passwordResetSuccess": "Password has been reset successfully. \nPlease sign-in with your new password.",
        "infoNetworkProblems1": "Dear customer, due to network problems, we are currently very limited in our accessibility via email and phone number. \nPlease contact your field service representative using the mobile number. \nYou can also find this phone number on this website under ",
        "infoNetworkProblemsLink": "https://safholland.com/int/en/",
        "infoNetworkProblems2": "We appreciate your understanding",
        "FLEET": "Fleet",
        "VEHICLE_DEALER": "Vehicle dealer",
        "WORKSHOP": "Workshop",
        "PARTS_DEALER": "Spare parts dealer",
        "softwarePageHeadline": "Software Deployment",
        "softwareTextHeadline": "Effortless Download",
        "softwareText1": "In the world of digital innovations, access to high-quality software plays a crucial role. In our I.Q. Portal, we have created a special area that allows you to download and install top-notch software with minimal effort. With just a few clicks, a world full of powerful applications opens up to you.",
        "softwareText2": "Once you have found the software you want, a single click is enough to start the download. Our system works efficiently to ensure that you receive the necessary files quickly, without long waiting times.",
        "softwareText3": "The installation is just as straightforward as the download. Simply follow the instructions displayed on the screen to install the software quickly and without any problems.",
        "toSoftware": "Go to Software",
        "navLabelSoftware": "Software"
    },
    "form": {
        "submitForm": "Submit form",
        "newUserFormStep1Label": "User",
        "newUserFormStep2Label": "Company",
        "newUserFormStepSuccessHeading": "Registration successful.",
        "newUserFormStepSuccessText": "Once you have been activated by an administrator, you can use the customer portal.",
        "newUserFormStep1Notification": "This data comes from your Azure profile.",
        "vehicleManufacturer": "Vehicle manufacturer",
        "workshop": "Workshop",
        "partsDealer": "Spare Part Dealer",
        "fleetOrDispatchDepartment": "Fleet",
        "salutationSIR": "Sir",
        "salutationMADAM": "Madam",
        "salutationDR": "Dr",
        "salutationPROF": "Prof",
        "acceptPrivacyPolicyText": "I hereby confirm that I have read and accept the <1>Privacy Policy</1>.",
        "acceptPrivacyPolicyInfo": "You must accept the privacy policy to continue.",
        "next": "Next",
        "back": "Back",
        "save": "Save",
        "submit": "Submit",
        "reset": "reset",
        "changeName": "Change name",
        "changePassword": "Change password",
        "spareAxleRequestFormStep1Label": "Contact Details",
        "spareAxleRequestFormStep2Label": "Axle Details",
        "spareAxleRequestFormStep3Label": "Summary",
        "spareAxleRequestFormStepSuccessHeading": "Spare Axle Request Sent Successfully",
        "spareAxleRequestFormStepSuccessText": "Your spare axle request has been sent successfully",
        "spareAxleRequestFormStepSuccessButton": "Make another request",
        "linkNeedHelp": "Do you need help?",
        "close": "Close"
    },
    "error": {
        "unknownErrorHasOccurred": "An unknown error has occurred",
        "logOutFailed": "Logout failed",
        "pageNotFound": "Page not found",
        "companyNameNotFound": "Company name not found",
        "appInitFailed": "The app could not be loaded. Please try again at a later time.",
        "inputInvalid": "invalid input",
        "atLeastOneElementMustBeCreated": "at least 1 element must be created",
        "theMinimumQuantityIs": "The minimum quantity is {{itemCount}}",
        "noOrderHasBeenPlaced": "No order was placed",
        "passwordsNotIdentical": "The password entries do not match",
        "passwordToShort": "The password is too short",
        "fileUploadFailed": "The file upload failed",
        "statusCode403": "Access denied",
        "statusCode404": "The server cannot be reached. Please try again at a later time.",
        "statusCode501": "This functionality is not yet available.",
        "mandatoryField": "Mandatory field",
        "signInError": "The login has failed. Please try again in a few minutes.",
        "signOutError": "The logout has failed. Please contact the administrator.",
        "editProfileError": "An error occurred while updating the profile. Please contact the administrator.",
        "invalidMailAddress": "invalid mail address",
        "fetchUserError": "An error occurred while retrieving the user data. Please contact an administrator.",
        "zipErrorMessage": "A ZIP code has exactly 5 digits",
        "emailErrorMessage": "No valid email",
        "phoneErrorMessage": "No valid phone number",
        "serialNumberErrorMessage": "A serial number must have exactly 11 digits",
        "cantDelete": "An error occurred during the deletion process. The object may still be related to other objects.",
        "cantUpdateNotFound": "The data could not be saved. They may not exist anymore.",
        "cantUpdate": "The data could not be saved. You may have assigned a value to a key attribute that already exists.",
        "lackingPermission": "You are not authorized to make the requested changes."
    },
    "link": {
        "dataProtection": "https://safholland.com/int/en/privacy-policy/#c4160",
        "imprint": "https://safholland.com/int/en/imprint-1",
        "course1": "https://safholland.com/de/en/events/event/advanced-training-course-23-01-2024",
        "course2": "https://safholland.com/de/en/events/event/haldex-ebs-training-06-02-2024",
        "course3": "https://safholland.com/de/en/events/event/system-training-courses-brake-technology-20-02-2024",
        "course4": "https://safholland.com/de/en/events/event/system-training-steering-axles-09-04-2024",
        "course5": "https://safholland.com/de/en/events/event/haldex-ebs-training-23-04-2024",
        "course6": "https://safholland.com/de/en/events/event/advanced-training-course-14-05-2024",
        "course7": "https://safholland.com/de/en/events/event/haldex-ebs-training-04-06-2024",
        "course8": "https://safholland.com/de/de/events/veranstaltung/haldex-ebs-schulung-20-08-2024",
        "course9": "https://safholland.com/de/en/events/event/system-training-driven-axle-saf-intra-cd-trak-08-10-2024",
        "courseOverview": "https://safholland.com/de/en/aftersales/trainings",
        "pod": "https://pod.safholland.de/shop/app?forcerestart=true",
        "course10": "https://safholland.com/de/en/events/event/advanced-training-course-15-10-2024",
        "course11": "https://safholland.com/de/en/events/event/haldex-ebs-training-22-10-2024",
        "course12": "https://safholland.com/de/en/events/event/haldex-ebs-training-12-11-2024",
        "course13": "https://safholland.com/de/en/events/event/system-training-courses-brake-technology-26-11-2024"
    },
    "course": {
        "linkToCourse": "Link to training",
        "course1": "23.01. Maintenance (Advanced Training) at SAF-HOLLAND Academy Aschaffenburg",
        "course2": "06. - 07.02. Electronic Brake System (EBS) SAF-HOLLAND Academy Aschaffenburg",
        "course3": "20.02. Brake Technology SAF-HOLLAND Academy Aschaffenburg",
        "course4": "April 9th, Steering Axles at SAF-HOLLAND Academy in Aschaffenburg",
        "course5": "April 23rd - 24th, Electronic Braking System (EBS) Professional Training Center Tuttlingen GmbH",
        "course6": "14.05. Maintenance (Advanced Training) SAF-HOLLAND Academy Aschaffenburg",
        "course7": "June 4th - 5th 2024, Electronic Brake System (EBS) at Frank Fahrzeugbau GmbH, Markranstädt",
        "course8": "August 20th - 21st 2024, Electronic Brake System (EBS) at Chamber of Crafts Münster",
        "course9": "October 8th 2024, Powered Axles at SAF-HOLLAND Academy Aschaffenburg",
        "course10": "October 15 2024, Maintenance (Advanced Training) SAF-HOLLAND Academy Aschaffenburg",
        "course11": "October 22-23 2024, Electronic Braking System (EBS) at Berger Truck Service GmbH, AT-Wörgl",
        "course12": "November 12-13 2024, Electronic Braking System (EBS) SAF-HOLLAND Academy Aschaffenburg",
        "course13": "26.11.2024 Brake Technology at SAF-HOLLAND Academy Aschaffenburg"
    }
};